import { Navigate, useParams } from "react-router-dom";
import { useGetPostByIdQuery } from "../../post.service";
import { EditScheduledPost as Edit } from "../../components/scheduled-posts/edit-scheduled-post";
import { ScheduledPost } from "../../types/scheduled-posts.entity";
import PageLoading from "src/components/pageLoading";

export const EditScheduledPost = () => {
  const { postId } = useParams();

  console.log("postId: ", postId);
  const { data: post, isLoading, isError } = useGetPostByIdQuery({ id: postId!, isScheduled: true });

  if (isError) return <Navigate to={"/404"} />;

  if (isLoading) return <PageLoading />;

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6 text-center">Edit Scheduled Post</h2>
      <Edit post={post as ScheduledPost} />
    </div>
  );
};
